import { MapPin, ArrowSquareOut } from "@phosphor-icons/react";

export const MapView = ({ latitude, longitude, address, name, city }) => {
  const hasCoords = latitude != null && longitude != null && !Number.isNaN(Number(latitude));
  const parts = [name, address, city].map((p) => (p || "").trim()).filter(Boolean);
  const query = encodeURIComponent(parts.join(", ") || "Hyderabad");
  const gmaps = `https://www.google.com/maps/search/?api=1&query=${query}`;

  if (hasCoords) {
    const d = 0.012;
    const bbox = `${Number(longitude) - d}%2C${Number(latitude) - d}%2C${Number(longitude) + d}%2C${Number(latitude) + d}`;
    const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${latitude}%2C${longitude}`;
    return (
      <div data-testid="map-view" className="overflow-hidden rounded-2xl border border-stone-200">
        <iframe title="Property location" src={src} className="h-56 w-full border-0" loading="lazy" referrerPolicy="no-referrer" sandbox="allow-scripts allow-same-origin allow-popups" />
        <a href={gmaps} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-1 bg-white py-2 text-sm font-medium text-primary hover:bg-accent">
          Open in Google Maps <ArrowSquareOut size={15} />
        </a>
      </div>
    );
  }

  return (
    <a
      href={gmaps}
      target="_blank"
      rel="noreferrer"
      data-testid="map-placeholder"
      className="flex h-40 flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-stone-300 bg-accent/40 text-center transition-colors hover:bg-accent"
    >
      <MapPin size={30} weight="duotone" className="text-primary" />
      <span className="px-6 text-sm font-medium text-stone-700">{parts.join(", ") || "Location on map"}</span>
      <span className="flex items-center gap-1 text-xs text-primary">View on Google Maps <ArrowSquareOut size={13} /></span>
    </a>
  );
};
